import { PaymentsCard } from '../Details/PaymentsCard'
import { PlanCard } from './PlanCard'
import { PlansComponent } from './PlansComponent'

export const PlansPage = () => {
  return (
    <div className="space-y-5">
      <PlanCard showChangePlanButton={false} />
      <PlansComponent />
      <PaymentsCard />
    </div>
  )
}
